import { SubmissionTypeEnum } from '../../models/users/enum/submission-type-enum';

export class MemberSubmissionPermissionUtils {
  static getViewSubmissionPermission(submissionTypeId: SubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case SubmissionTypeEnum.NameChange:
        return 1;
      case SubmissionTypeEnum.AddressChange:
        return 7;
      case SubmissionTypeEnum.UpdatePhoneNumber:
        return 13;
      case SubmissionTypeEnum.PersonalDetailsChange:
        return 19;
      case SubmissionTypeEnum.ChangeInvestmentInstructions:
        return 25;
      case SubmissionTypeEnum.RelationshipStatusChange:
        return 31;
      case SubmissionTypeEnum.BeneficiaryChange:
        return 37;
      case SubmissionTypeEnum.BankingInformation:
        return 43;
      case SubmissionTypeEnum.MemberSelfEnrolment:
        return 49;
      case SubmissionTypeEnum.UpdateLegalFiduciary:
        return 55;
      case SubmissionTypeEnum.VariableBenefitConfiguration:
        return 61;
      case SubmissionTypeEnum.UpdateBeneficiariesVariableBenefit:
        return 67;
      case SubmissionTypeEnum.UpdateVariableBenefitAccountConfiguration:
        return 73;
      case SubmissionTypeEnum.VariableBenefitPaymentChange:
        return 97;
      case SubmissionTypeEnum.AnnuitySetup:
        return 103;
      case SubmissionTypeEnum.UpdateAnnuityBeneficiaries:
        return 115;
      case SubmissionTypeEnum.TransferIn:
        return 121;

      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getProcessSubmissionPermission(submissionTypeId: SubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case SubmissionTypeEnum.NameChange:
        return 2;
      case SubmissionTypeEnum.AddressChange:
        return 8;
      case SubmissionTypeEnum.UpdatePhoneNumber:
        return 14;
      case SubmissionTypeEnum.PersonalDetailsChange:
        return 20;
      case SubmissionTypeEnum.ChangeInvestmentInstructions:
        return 26;
      case SubmissionTypeEnum.RelationshipStatusChange:
        return 32;
      case SubmissionTypeEnum.BeneficiaryChange:
        return 38;
      case SubmissionTypeEnum.BankingInformation:
        return 44;
      case SubmissionTypeEnum.MemberSelfEnrolment:
        return 50;
      case SubmissionTypeEnum.UpdateLegalFiduciary:
        return 56;
      case SubmissionTypeEnum.VariableBenefitConfiguration:
        return 62;
      case SubmissionTypeEnum.UpdateBeneficiariesVariableBenefit:
        return 68;
      case SubmissionTypeEnum.UpdateVariableBenefitAccountConfiguration:
        return 74;
      case SubmissionTypeEnum.VariableBenefitPaymentChange:
        return 98;
      case SubmissionTypeEnum.AnnuitySetup:
        return 104;
      case SubmissionTypeEnum.UpdateAnnuityBeneficiaries:
        return 116;
      case SubmissionTypeEnum.TransferIn:
        return 122;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanApproveSubmissionPermission(submissionTypeId: SubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case SubmissionTypeEnum.NameChange:
        return 3;
      case SubmissionTypeEnum.AddressChange:
        return 9;
      case SubmissionTypeEnum.UpdatePhoneNumber:
        return 15;
      case SubmissionTypeEnum.PersonalDetailsChange:
        return 21;
      case SubmissionTypeEnum.ChangeInvestmentInstructions:
        return 27;
      case SubmissionTypeEnum.RelationshipStatusChange:
        return 33;
      case SubmissionTypeEnum.BeneficiaryChange:
        return 39;
      case SubmissionTypeEnum.BankingInformation:
        return 45;
      case SubmissionTypeEnum.MemberSelfEnrolment:
        return 51;
      case SubmissionTypeEnum.UpdateLegalFiduciary:
        return 57;
      case SubmissionTypeEnum.VariableBenefitConfiguration:
        return 63;
      case SubmissionTypeEnum.UpdateBeneficiariesVariableBenefit:
        return 69;
      case SubmissionTypeEnum.UpdateVariableBenefitAccountConfiguration:
        return 75;
      case SubmissionTypeEnum.VariableBenefitPaymentChange:
        return 99;
      case SubmissionTypeEnum.AnnuitySetup:
        return 105;
      case SubmissionTypeEnum.UpdateAnnuityBeneficiaries:
        return 117;
      case SubmissionTypeEnum.TransferIn:
        return 123;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanApproveOwnSubmissionPermission(submissionTypeId: SubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case SubmissionTypeEnum.NameChange:
        return 4;
      case SubmissionTypeEnum.AddressChange:
        return 10;
      case SubmissionTypeEnum.UpdatePhoneNumber:
        return 16;
      case SubmissionTypeEnum.PersonalDetailsChange:
        return 22;
      case SubmissionTypeEnum.ChangeInvestmentInstructions:
        return 28;
      case SubmissionTypeEnum.RelationshipStatusChange:
        return 34;
      case SubmissionTypeEnum.BeneficiaryChange:
        return 40;
      case SubmissionTypeEnum.BankingInformation:
        return 46;
      case SubmissionTypeEnum.MemberSelfEnrolment:
        return 52;
      case SubmissionTypeEnum.UpdateLegalFiduciary:
        return 58;
      case SubmissionTypeEnum.VariableBenefitConfiguration:
        return 64;
      case SubmissionTypeEnum.UpdateBeneficiariesVariableBenefit:
        return 70;
      case SubmissionTypeEnum.UpdateVariableBenefitAccountConfiguration:
        return 76;
      case SubmissionTypeEnum.VariableBenefitPaymentChange:
        return 100;
      case SubmissionTypeEnum.AnnuitySetup:
        return 106;
      case SubmissionTypeEnum.UpdateAnnuityBeneficiaries:
        return 118;
      case SubmissionTypeEnum.TransferIn:
        return 124;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanReassignSubmissionOwnerPermission(submissionTypeId: SubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case SubmissionTypeEnum.NameChange:
        return 5;
      case SubmissionTypeEnum.AddressChange:
        return 11;
      case SubmissionTypeEnum.UpdatePhoneNumber:
        return 17;
      case SubmissionTypeEnum.PersonalDetailsChange:
        return 23;
      case SubmissionTypeEnum.ChangeInvestmentInstructions:
        return 29;
      case SubmissionTypeEnum.RelationshipStatusChange:
        return 35;
      case SubmissionTypeEnum.BeneficiaryChange:
        return 41;
      case SubmissionTypeEnum.BankingInformation:
        return 47;
      case SubmissionTypeEnum.MemberSelfEnrolment:
        return 53;
      case SubmissionTypeEnum.UpdateLegalFiduciary:
        return 59;
      case SubmissionTypeEnum.VariableBenefitConfiguration:
        return 65;
      case SubmissionTypeEnum.UpdateBeneficiariesVariableBenefit:
        return 71;
      case SubmissionTypeEnum.UpdateVariableBenefitAccountConfiguration:
        return 77;
      case SubmissionTypeEnum.VariableBenefitPaymentChange:
        return 101;
      case SubmissionTypeEnum.AnnuitySetup:
        return 107;
      case SubmissionTypeEnum.UpdateAnnuityBeneficiaries:
        return 119;
      case SubmissionTypeEnum.TransferIn:
        return 125;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanCreateSubmissionPermission(submissionTypeId: SubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case SubmissionTypeEnum.NameChange:
        return 6;
      case SubmissionTypeEnum.AddressChange:
        return 12;
      case SubmissionTypeEnum.UpdatePhoneNumber:
        return 18;
      case SubmissionTypeEnum.PersonalDetailsChange:
        return 24;
      case SubmissionTypeEnum.ChangeInvestmentInstructions:
        return 30;
      case SubmissionTypeEnum.RelationshipStatusChange:
        return 36;
      case SubmissionTypeEnum.BeneficiaryChange:
        return 42;
      case SubmissionTypeEnum.BankingInformation:
        return 48;
      case SubmissionTypeEnum.MemberSelfEnrolment:
        return 54;
      case SubmissionTypeEnum.UpdateLegalFiduciary:
        return 60;
      case SubmissionTypeEnum.VariableBenefitConfiguration:
        return 66;
      case SubmissionTypeEnum.UpdateBeneficiariesVariableBenefit:
        return 72;
      case SubmissionTypeEnum.UpdateVariableBenefitAccountConfiguration:
        return 78;
      case SubmissionTypeEnum.VariableBenefitPaymentChange:
        return 102;
      case SubmissionTypeEnum.AnnuitySetup:
        return 108;
      case SubmissionTypeEnum.UpdateAnnuityBeneficiaries:
        return 120;
      case SubmissionTypeEnum.TransferIn:
        return 126;

      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }
}
